// src/hooks/useDarkMode.js
import { useEffect, useState } from 'react';

export default function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === 'undefined') {
      return false; // Valor por defecto para el renderizado del lado del servidor (SSR)
    }
    const stored = localStorage.getItem('theme');
    if (stored) return stored === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  // Agregamos un estado para indicar que el componente ya se ha montado y el tema inicial se ha establecido.
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
    // Una vez que el efecto se ha ejecutado, marcamos el componente como montado.
    setMounted(true);
  }, [isDark]);

  const toggle = () => setIsDark(prev => !prev);

  // Devolvemos el estado del tema y un indicador de que el componente está montado.
  return [isDark, toggle, mounted];
}